export const locationsEndpoints = {
  createLocations: "/client/locations",
  getLocationDropdown: "/dropdown",
  getLocationList: "/client/locations",
  getAllLocations: "/client/locations",
  lookups: "/dropdown/lookups",
  /** Lookup type param values for GET /dropdown/lookups?type=... */
  lookupTypes: {
    clientLocationStatus: "client_location_status",
    clientLocationType: "client_location_type",
    timezone: "timezone",
  } as const,
  clientBrands: "/dropdown/client-brands",
  clientLocationAddresses: "/dropdown/clientLocation-allAddresses",
  /** Zipcode dropdown: GET /dropdown/client-location-addresses?type=zipcode */
  clientLocationAddressesZipcode: "/dropdown/client-location-addresses",
  /** Base for client-scoped dropdowns: /dropdown/client/{clientId}/{pathSuffix} */
  clientDropdown: "/dropdown/client",
  locationActiveWorkOrders: "location-active-work-orders",
  locationZipcodes: "location-zipcodes",
  locationPhones: "location-phones",
};
